<template>

</template>

<script>
    export default {
        name: "DailyMe"
    }
</script>

<style scoped>

</style>
